module.exports = __webpack_public_path__ + "img/ic_renzhengzhong.2b883618.svg";